import { TabsGroup } from '@billy/design-system'
import { ReactElement } from 'react'

import { useVatDeclaration } from '../../../../context/vatDeclarationContext'
import { CorrectionTab } from './elements/CorrectionTab'

export const VatDeclarationCorrectionsTabs = (): ReactElement => {
  const { corrections, id } = useVatDeclaration()

  return (
    <TabsGroup>
      {corrections?.map(({ correctionNo, salesTaxReturnId }) => (
        <CorrectionTab
          key={salesTaxReturnId}
          correctionNo={correctionNo}
          correctionVatDeclarationId={salesTaxReturnId}
          isActive={id === salesTaxReturnId}
          numOfCorrections={corrections.length}
        />
      ))}
    </TabsGroup>
  )
}
